export default {
  createRingBuffer: function(length) {
    var pointer = 0, buffer = [] 
  
    return {
      all  : buffer,
      get  : function(key){return buffer[key]},
      push : function(item){
        buffer[pointer] = item
        pointer = (length + pointer +1) % length
      }
    }
  }
}